import React from 'react';
import { FormOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface NavPageModel {
  label: string | React.ReactNode;
  key: string;
  icon?: React.ReactNode;
  path?: string[];
  url?: string;
}

interface NavItemModel extends NavPageModel {
  sections?: NavItemModel[];
}

const navPages: { [key: string]: NavPageModel } = {
  home: {
    label: <Link to="/">Generator</Link>,
    key: 'home',
    icon: <FormOutlined />,
  },
  support: {
    label: <Link to="/support">Support</Link>,
    key: 'support',
    icon: <QuestionCircleOutlined />,
  },
};

const mainNav: NavItemModel[] = [navPages.home, navPages.support];

export { navPages, mainNav };
export type { NavItemModel };
